module.exports = __webpack_public_path__ + "img/ic_konka_logo_normal.f007da2.png";